'use strict';

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.splice.js";
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";

function NavigationService(vueComponent) {
  this.vueComponent = vueComponent; //this.Paths= [];

  this.GetPaths = function () {
    var paths = [];

    if (Utility.GetSession("NavigationPath") == null) {
      Utility.SaveSession("NavigationPath", []);
    }

    paths = Utility.GetSession("NavigationPath");
    return paths;
  }, this.SavePaths = function (paths) {
    paths = Utility.SaveSession("NavigationPath", paths);
  }, this.GoTo = function (path, argumentObject) {
    var absolutePath = path;
    var paths;
    var currPath;
    paths = this.GetPaths();
    currPath = window.location.pathname + window.location.search;

    if (!this.MatchLastPath()) {
      paths.push({
        Path: currPath
      });
    }

    if (path[0] != '/') {
      absolutePath = this.ConvertToAbsolutePath(path);
    }

    paths.push({
      Path: absolutePath,
      Argument: argumentObject,
      CreateTime: new Date()
    });
    this.SavePaths(paths);
    this.vueComponent.$router.push(path);
  };
  this.Goto = this.GoTo;

  this.ConvertToAbsolutePath = function (path) {
    var absolutePath;
    var linkElement = document.createElement("a");
    linkElement.href = path + "";
    absolutePath = linkElement.pathname + linkElement.search + linkElement.hash;
    return absolutePath;
  };

  this.GoBack = function () {
    var pathInfo;
    var paths;
    paths = this.GetPaths();

    if (paths.length > 0) {
      this.PopPath();
      pathInfo = this.PeekPath();
      this.vueComponent.$router.push(pathInfo.Path);
    } else {
      this.vueComponent.$router.go(-1);
    }
  };

  this.MatchLastPath = function () {
    var paths;
    var match = false;
    var pathInfo;
    var currPath;
    paths = this.GetPaths();
    currPath = window.location.pathname + window.location.search;

    if (paths.length > 0) {
      pathInfo = this.PeekPath();

      if (pathInfo.Path == currPath) {
        match = true;
      }
    }

    return match;
  }, //end this.MatchLastPath = function () {
  this.PushPath = function (pathInfo) {
    var paths;
    paths = this.GetPaths();
    paths.push(pathInfo);
    this.SavePaths(paths);
  }, this.PeekPath = function () {
    var pathInfo = null;
    var paths;
    paths = this.GetPaths();

    if (paths.length > 0) {
      pathInfo = paths[paths.length - 1];
    }

    return pathInfo;
  }, this.PopPath = function () {
    var pathInfo = null;
    var paths;
    paths = this.GetPaths();

    if (paths.length > 0) {
      pathInfo = paths[paths.length - 1];
      paths.splice(paths.length - 1, 1);
    }

    this.SavePaths(paths);
    return pathInfo;
  };
}

export default NavigationService;